var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"meta-wrapper"},[(_vm.metadata)?_c('div',{staticStyle:{"word-wrap":"break-word"}},[_c('vue-json-pretty',{attrs:{"data":_vm.metadata,"highlightMouseoverNode":true}})],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }